import { render, staticRenderFns } from "./criarEventoDialog.vue?vue&type=template&id=554ce08f"
import script from "./criarEventoDialog.vue?vue&type=script&lang=js"
export * from "./criarEventoDialog.vue?vue&type=script&lang=js"
import style0 from "./criarEventoDialog.vue?vue&type=style&index=0&id=554ce08f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports